import { api } from "@/redux/api";

import {
	AddProspectsToCrmRequest,
	AddProspectsToCrmRequestSchema,
	AddProspectsToCrmResponse,
	AddProspectsToCrmResponseSchema,
} from "./crm.schema";

export const crmApi = api.injectEndpoints({
	endpoints: (builder) => ({
		addProspectsToCrm: builder.mutation<AddProspectsToCrmResponse, AddProspectsToCrmRequest>({
			query: (body) => ({
				url: "crm/add-prospects",
				method: "POST",
				body,
				requestSchema: AddProspectsToCrmRequestSchema,
				responseSchema: AddProspectsToCrmResponseSchema,
			}),
			invalidatesTags: [
				"Crm",
				"Contact",
				"ListPerson",
				"Hubspot",
				"Zoho",
				"Pipedrive",
				"Dynamics",
				"Salesforce",
			],
		}),
	}),
});

export const { useAddProspectsToCrmMutation } = crmApi;
